<script>
  export let buttonImage;
  export let buttonFunction;
</script>

<div
  class="gpb-item"
  on:click={buttonFunction}
>
  {#if buttonImage !== undefined}
    <img src={buttonImage}>
  {/if}
</div>

<style>
  div.gpb-item {
    position: relative;
    padding: 0.5em 0.5em;
    color: #00468F;
    text-align: center;
    background-color: white;
    cursor: pointer;
  }
  div.gpb-item:hover {
    background-color: #EEEEEE;
  }
  div.gpb-item:active {
    background-color: #DDDDDD;
  }
</style>
